export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NewsListing.vue?vue&type=template&id=7e157a57&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/NewsListing.vue?vue&type=template&id=7e157a57&scoped=true&
// module id = 352
// module chunks = 0